export const agentTasksKeys = {
    all: () => ['agentTasks']
};
//# sourceMappingURL=agentTasks.keys.js.map